module.exports = __webpack_public_path__ + "static/media/telephone-white.04e70784.svg";